import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseStepComponent} from '../base-step/base-step.component';
import {GuestCredit} from '../../shared/models/guest-credit';
import {WORKFLOW_DATA_SERVICE_TOKEN} from '../../shared/services/workflow-data.service';
import {NavigationService} from '../../shared/services/navigation.service';

@Component({
  selector: 'app-guest-credit-step',
  templateUrl: './guest-credit-step.component.html',
  styleUrls: ['./guest-credit-step.component.css']
})
export class GuestCreditStepComponent extends BaseStepComponent implements OnInit, OnDestroy {
  public guests: Array<GuestCredit> = [];
  private subscription: any;

  constructor(route: ActivatedRoute, @Inject(WORKFLOW_DATA_SERVICE_TOKEN) private workflowDataService,
              navigationService: NavigationService, router: Router) {
    super(route, navigationService, router);
  }

  ngOnInit() {
    this.subscription =  this.workflowDataService.getGuestCredits.subscribe(data => {
      this.guests = data;
    });
  }

  ngOnDestroy() {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/steps/guest-credit-step/guest-credit-step.component.ts